import React from 'react';
import { Container } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faInstagram, faTwitter, faFacebook, faPinterest } from '@fortawesome/free-brands-svg-icons';

const Footer = () => {
  return (
    <div className='footer-wrapper'>
      <Container>
        <div 
          style={{height: "140px"}} 
          className='d-flex align-items-center d-flex justify-content-between'
        >
          <Link to="/#" className='footer-home-button text-decoration-none text-black'>Turquoise.</Link>
          <div>
            <Link to="">
              <FontAwesomeIcon style={{fontSize:"24px"}} className='m-1 text-black-50 h-t-black' icon={faInstagram} /> 
            </Link>
            <Link to="">
              <FontAwesomeIcon style={{fontSize:"24px"}} className='m-1 text-black-50 h-t-black' icon={faTwitter} />  
            </Link>
            <Link to="">
              <FontAwesomeIcon style={{fontSize:"24px"}} className='m-1 text-black-50 h-t-black' icon={faFacebook} />  
            </Link>
            <Link to="">
              <FontAwesomeIcon style={{fontSize:"24px"}} className='m-1 text-black-50 h-t-black' icon={faPinterest} />  
            </Link>
          </div>
        </div>
      </Container>
    </div> 
  )
}

export default Footer